import React, { useState, useEffect } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { Input, Drawer, Checkbox } from 'antd';
import {
  HolderOutlined
} from '@ant-design/icons';
import './ColSeting.scss';

const ShowSettingV3 = ({ stData = {} as any, onChange = (data: any, type: any) => { } }) => {
  const [colDefs, setColDefs] = useState([] as any)
  const [obCheck, setObcheck] = useState({} as any)

  useEffect(() => {
    setColDefs([...stData.col])
  }, [stData.col])

  const handleOnDragEnd = (result: any) => {
    if (!result.destination) return;

    const items = Array.from(colDefs);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setColDefs([...items]);
  };

  // const changeCheck = (data: any) => {
  //   let temp = { ...obCheck } as any
  //   if (data.value === true) {
  //     temp[`key${data.item.key}`] = data.item
  //   } else {
  //     delete temp[`key${data.item.key}`]
  //   }
  //   setObcheck({ ...temp })
  // }
  const [searchValue, setSearchValue] = useState('')
  // Helper function to remove Vietnamese diacritics
  const removeVietnameseTones = (str: string) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  const filteredColDefs = colDefs.filter((item: any) =>
    removeVietnameseTones(item.headerName || '')
      .toLowerCase()
      .includes(removeVietnameseTones(searchValue).toLowerCase())
  );

  return (
    <Drawer title="Basic Drawer" onClose={() => onChange({}, 'close')} open={stData.open}>
      <div
        className="filter-setting"
      >
        <div className="title-add-filter">
          <span>Nâng cao</span>
        </div>
        <div className="content-filter-setting t-scrollbar">
          <div className="title-content">Tùy chỉnh trường hiển thị trên bảng</div>
          <div className='input-filter-header'>
            <Input
              placeholder="Tìm kiếm theo tên cột"
              className="rs-input"
              value={searchValue}
              onChange={e => setSearchValue(e.target.value)}
              allowClear
            />
          </div>
          <div className="list-add-filter-content">
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <Droppable droppableId="menu">
                {(provided) => (
                  <ul {...provided.droppableProps} ref={provided.innerRef} className="drag-drop-content customer-head-list-setting" >
                    {colDefs.map((item: any, index: any) => (
                      <Draggable key={item.colId} draggableId={item.colId.toString()} index={index}>
                        {(provided: any) => (
                          <li
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            className={`one-op ${!item.hide ? 'active' : ''} ${searchValue ? filteredColDefs.some((x: any) => x.colId === item.colId) ? '' : 'hidden-x' : ''}`}
                          >
                            <HolderOutlined className="icon" />
                            <div className="text">
                              <Checkbox
                                className="one-add-filter-content"
                                checked={!item.hide}
                                onChange={(e: any) => {
                                  const findData = colDefs.find((x: any) => x.colId === item.colId)
                                  findData.hide = !e.target.checked
                                  setColDefs([...colDefs])
                                }}
                              >
                                <div className="label">{item.headerName || 'check'}</div>
                              </Checkbox>
                            </div>
                          </li>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </ul>
                )}
              </Droppable>
            </DragDropContext>

          </div>
        </div>
        <div className="footer-filter-block">
          <div className="btn-block">
            <div className="btn btn-primary" onClick={() => {
              let temp = {} as any
              colDefs.map((val: any, index: any) => {
                temp[val.colId] = {
                  ...val,
                  pos: index,
                }
                return true
              })
              onChange(colDefs, 'saveChange')
            }}>
              <div className="text">
                Lưu
              </div>
            </div>
          </div>
        </div>
      </div>

    </Drawer>
  );
};

export default ShowSettingV3;
